export type PlaygroundMsgValues = Record<string, string | number>;

export const interpolatePlaygroundMessage = (
  message: string,
  values?: PlaygroundMsgValues
): string => {
  if (!values) {
    return message;
  }

  return message.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = values[key];
    return value === undefined ? match : String(value);
  });
};
